export const DefaultGetEventRequestArgs = {
  eventId: '',
};
